'use strict';

import { environment } from '@quartz-gov-legacy/environments/environment';

angular.module('controlModule')

.factory('grcControlService', ['$http', function ($http) {
    var baseUrl = environment.apiUrl + '/Pilot/api/Control';

    var service = {};

    // Control
    service.getControl = function (controlId) {
        return $http
            .get(baseUrl + '/' + controlId)
            .then(function (response) { return response.data; });
    };
    service.createOrUpdateControl = function (control) {
        var reqUrl = baseUrl;
        if (!_.isUndefined(control.ControlID)) reqUrl += '/' + control.ControlID;

        return $http
            .post(reqUrl, { Control: control })
            .then(function (response) { return response.data; });
    };
    service.closeControl = function (control) {
        return $http
            .post(baseUrl + '/' + control.ControlID + '/Close', { Control: control })
            .then(function (response) { return response.data; });
    };
    service.getHistoricOnControl = function (controlId) {
        return $http
            .get(baseUrl + '/' + controlId + '/Historic')
            .then(function (response) { return response.data; });
    };

    // Related Risks
    service.getRisksByControl = function (controlId) {
        return $http
            .get(baseUrl + '/' + controlId + '/Risk')
            .then(function (response) { return response.data; });
    };
    service.addRiskToControl = function (controlId, riskId) {
        return $http
            .post(baseUrl + '/' + controlId + '/Risk/' + riskId)
            .then(function (response) { return response.data; });
    };
    service.removeRiskFromControl = function (controlId, riskId) {
        return $http
            .delete(baseUrl + '/' + controlId + '/Risk/' + riskId)
            .then(function (response) { return response.data; });
    };

    // Control Tests
    service.getControlTest = function (controlTestId) {
        return $http.get(environment.apiUrl + '/Test/' + controlTestId)
                    .then(function (response) { return response.data; });
    };

    service.getControlTests = function (controlId, opts) {
        return $http.get(baseUrl + '/' + controlId + '/Test', opts)
                    .then(function (response) { return response.data; });
    };

    service.createOrUpdateControlTest = function (controlId, controlTest) {
        return $http.post(baseUrl + '/' + controlId + '/Test',
                          controlTest)
                    .then(function (response) {
                        return response.data;
                    });
    };
    service.closeControlTest = function (controlTest) {
        return $http
            .post(baseUrl + '/' + controlTest.ControlID + '/Test/' + controlTest.ControlTestID + '/Close', { ControlTest: controlTest })
            .then(function (response) { return response.data; });
    };

    // Get Test Results
    service.getTestResults = function (controlId, controlTestId, opts) {
        return $http.get(baseUrl + '/' + controlId + '/Test/' + controlTestId + '/Result', opts)
                    .then(function (response) { return response.data; });
    };

    // Create Or Update TestResult
    service.createOrUpdateTestResult = function (controlId, testResult) {
        var reqUrl = baseUrl + '/' + controlId + '/Test/' + testResult.ControlTestID + '/Result';
        var deferred;

        if (testResult.TestResultID) {
            reqUrl += '/' + testResult.TestResultID;
        }

        return $http.post(reqUrl, testResult)
                    .then(function (response) {
                        return response.data;
                    });
    };

    // Submit Test Result
    service.submitTestResult = function (controlId, testResult) {
        var reqUrl = baseUrl + '/' + controlId +
                     '/Test/' + testResult.ControlTestID +
                     '/Result/' + testResult.TestResultID + '/Submit';

        return $http.post(reqUrl, testResult)
                    .then(function (response) {
                        return response.data;
                    });
    };

    // Lookups
    service.getAllLookups = function () {
        return $http
            .get(baseUrl + '/Lookup', { cache: true, ignoreError: true })
            .then(function (response) { return response.data; });
    };

    // Coso Points of Focus
    service.getAllCosoPointsOfFocus = function () {
        return $http
            .get(environment.apiUrl + '/Pilot/api/CosoPointOfFocus', { cache: true })
            .then(function(response) { return response.data; });
    };

    // Financial Statements
    service.getAllFinancialStatements = function () {
        return $http
            .get(environment.apiUrl + '/Pilot/api/FinancialStatement', { cache: true })
            .then(function (response) { return response.data; });
    };

    // Download Attachment URL
    service.getDownloadAttachmentUrl = function (controlId, controlTestId, attachmendId) {
        return baseUrl + '/' + controlId + '/Test/' + controlTestId + '/Attachment/' + attachmendId;
    };

    return service;
}]);
